import { useContext, useMemo, Context } from "react"
import { CONTENT_SET_TEMPLATE_PREFIX } from "connected-components/graph/components/template-selector"
import { GraphContextValue } from "connected-components/graph/types"
import { useContentSetContext, ContentSetMetadata } from "./context"

interface ActiveContentSetResult {
  selectedContentSetId: string | null
  activeContentSet: ContentSetMetadata | null
}

export function useActiveContentSet(context: Context<GraphContextValue>): ActiveContentSetResult {
  const { selectedTemplate } = useContext(context)
  const { contentSetsMetadata } = useContentSetContext()

  const selectedContentSetId = selectedTemplate?.startsWith(CONTENT_SET_TEMPLATE_PREFIX)
    ? selectedTemplate.slice(CONTENT_SET_TEMPLATE_PREFIX.length)
    : null

  const activeContentSet = useMemo((): ContentSetMetadata | null => {
    if (!contentSetsMetadata || !selectedContentSetId) return null
    return contentSetsMetadata.find(cs => cs.id === selectedContentSetId) ?? null
  }, [contentSetsMetadata, selectedContentSetId])

  return { selectedContentSetId, activeContentSet }
}
